import styled from 'styled-components';
import { Grid, colors } from '@dexma/ui-components';
import { headerHeight } from 'adapter/in/dashboards/pages/globalStyles';
import { alertHeight } from 'adapter/in/common/context/Alert';

type EditDashboardPageProps = {
    $showAlert: boolean;
};
export const StyledEditDashboardsPage = styled(Grid)<EditDashboardPageProps>`
    padding-right: 0.5rem;
    padding-left: 0.5rem;
    height: 100%;
    overflow: hidden;
    background-color: ${colors.gray100};
    .layout {
        overflow: hidden;
        position: relative;
        height: ${(props) => (props.$showAlert ? `calc(100% - ${alertHeight} - ${headerHeight})` : `calc(100% - ${headerHeight})`)};
    }
`;
